// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29bcL","icon":"styles_icon__19BTN"};